import { render, staticRenderFns } from "./CampaignQuestion.vue?vue&type=template&id=f6a7b200&"
import script from "./CampaignQuestion.vue?vue&type=script&lang=js&"
export * from "./CampaignQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports